import { http } from '../../../api/axios';
import { localContentConfig } from '../../../config';
import { CountryOut } from '../../../store/apiLibx';

export const fetchCountries = () => {
    return http
        .get<{ countries: CountryOut[] }>(localContentConfig().endpointCountries)
        .then(response => response.data.countries);
};
